export let colourIterator = 0;
export const defaultCenter = { lat: 53.6447783, lng: -1.7397406 };
export const defaultZoom = 7;
export let mapIsZoomed = false;
export let mapIsTrackingDriver= null;

export function selectColourH(colour, totalColours) {
    // https://stackoverflow.com/a/20129594
    // defaults to one colour - avoid divide by zero
    if (totalColours < 1) {
        totalColours = 1;
    }
    return Math.floor(colour * (360 / totalColours) % 360);
}

export function makeHSL(colour) {
    return `hsl(${colour.h}, ${colour.s}%, ${colour.l}%)`;
}
